import { createElementVNode as _createElementVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_na-mapi" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "rightClose" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_x" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapCustom = _resolveComponent("MapCustom")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", {
      class: "openMap buttonMap",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMap && _ctx.openMap(...args))),
      tabindex: "0",
      onKeypress: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.openMap && _ctx.openMap(...args)), ["enter"]))
    }, _hoisted_2, 32),
    _createVNode(_component_Dialog, {
      visible: _ctx.showMap,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showMap) = $event)),
      class: "fullScreenMap"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_MapCustom, {
            markers: _ctx.markers,
            center: _ctx.center,
            onCenterChanged: _ctx.updateCenter,
            onZoomChanged: _ctx.updateZoom,
            onClose: _ctx.closeMap
          }, null, 8, ["markers", "center", "onCenterChanged", "onZoomChanged", "onClose"]),
          _createElementVNode("span", {
            class: "openMap buttonMap",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeMap && _ctx.closeMap(...args))),
            tabindex: "0",
            onKeypress: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeMap && _ctx.closeMap(...args)), ["enter"]))
          }, _hoisted_5, 32)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}